<script setup lang="ts" name="TimelineCharRowShader">
import { CATEGORICAL_DAVIZ_COLORS_TO_TAG } from '~/constants';

const { color } = defineProps<{
  leftOffset: number;
  width: number;
  color: string;
}>();

const LOOKUP_COLOR = {
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.OCEAN_8]: 'bg-ocean-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.ORANGE_3]: 'bg-orange-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.OCEAN_4]: 'bg-ocean-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.PURPLE_3]: 'bg-purple-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.NAVY_BLUE_7]: 'bg-navy-blue-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.MAGENTA_8]: 'bg-magenta-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.INDIGO_9]: 'bg-indigo-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.AMBER_9]: 'bg-amber-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.CHESTNUT_9]: 'bg-chestnut-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.PINK_4]: 'bg-pink-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.NAVY_BLUE_10]: 'bg-navy-blue-1',
  [CATEGORICAL_DAVIZ_COLORS_TO_TAG.GREEN_8]: 'bg-green-1',
};

const backgroundColor = LOOKUP_COLOR[color];
</script>

<template>
  <div
    class="absolute h-[36px] rounded-md opacity-30"
    :class="backgroundColor"
    :style="{
      left: `${leftOffset}px`,
      width: `${width}px`,
    }"
  ></div>
</template>
